import {
  FETCH_DRIVERS_DOCUMENTS_TYPES_DATA,
  FETCH_DRIVERS_DOCUMENTS_TYPES_SUCCESS,
  FETCH_DRIVERS_DOCUMENTS_TYPES_FAILURE,
} from "./actionTypes";

export const fetchDriversDocumentsTypesData = () => ({
  type: FETCH_DRIVERS_DOCUMENTS_TYPES_DATA,
});

export const fetchDriversDocumentsTypesSuccess = (data) => ({
  type: FETCH_DRIVERS_DOCUMENTS_TYPES_SUCCESS,
  payload: data,
});

export const fetchDriversDocumentsTypesFailure = (error) => ({
  type: FETCH_DRIVERS_DOCUMENTS_TYPES_FAILURE,
  payload: error,
});
